/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { PlayerLiveTuning } from "../../shared/types";

export interface PlayerRuntimeConfig {
  withCredentials?: boolean;
  liveTuning?: PlayerLiveTuning;
  chromecastReceiverId?: string;
}

let runtimeConfig: PlayerRuntimeConfig = {};

export function setPlayerRuntimeConfig(config: PlayerRuntimeConfig) {
  runtimeConfig = config;
}

export function getPlayerRuntimeConfig(): PlayerRuntimeConfig {
  return runtimeConfig;
}
